// extracted by mini-css-extract-plugin
export default {"buttonContainer":"EquipmentCreateView_buttonContainer__65nhK","formBody":"EquipmentCreateView_formBody__cYTmj","formRow":"EquipmentCreateView_formRow__wC0fR"};